import React, { useState } from 'react'

import Delv from 'delv/delv-react'
import Mutation from 'delv/Mutation'
import OrderBy from 'common/OrderBy.js'
import Map from 'common/Map.js'
import Div from 'common/Div.js'
import Loading from 'common/loading/index.js'
import Template from './template/index.js'
import './Templates.scss'

const GET_SIGNING_TEMPALTES = {
    query: `{
  allPaymentIssuers{
    nodes{
      ${Template.fragment}
    }
  }
}`,
    format: (data) => ({
        orderByData: data.allPaymentIssuers.nodes,
    }),
}

const Right = ({ match }) => (
    <div className='vrtl-signing-templates__container--templates'>
        <div className='gray-header'>Issuers</div>
        <Delv.query {...GET_SIGNING_TEMPALTES}>
            <OrderBy.order>
                <Template.orderByHeader />
                <Div className='buyers-container'>
                    <Div className='order-by-inner'>
                        <Map arrayKey='_orderBy.data'>
                            <Template.row match={match} />
                        </Map>
                    </Div>
                </Div>
            </OrderBy.order>
        </Delv.query>
    </div>
)

const SYNC_TEMPLATES = `mutation ($id: UUID!) {
  northCapitalSync(input: $id) {
    id
    syncedOn
    paymentIssuersByPaymentAccountId{
      nodes {
        ${Template.fragment}
      }
    }
  }
}`

const Left = ({
    allPaymentAccounts: {
        nodes: [{
            id,
        }],
    },
}) => {
    const [state, setState] = useState('sync')
    const handleSubmit = (event) => {
        event.preventDefault()
        new Mutation({
            mutation: SYNC_TEMPLATES,
            onSubmit: () => {
                setState('loading')
                return {
                    id,
                }
            },
            onResolve: () => setState('sync'),
            onError: () => setState('error'),
        }).submit()
    }
    return (
        <div className='vrtl-signing-left__section'>
            <div className='vrtl-signing__header'>North Capital Account</div>
            <div className='error'>{state === 'error' && 'Error loading templates, please try agian.'}</div>
            {
                state === 'loading'
                    ? <Loading.dots />
                    : <div className='vrtl-step-card--action-btn vrtl-signing__button' onClick={handleSubmit}>Sync template list</div>
            }
        </div>
    )
}

Left.delvConfig = {
    query: `{
  allPaymentAccounts{
    nodes{
      id
      syncedOn
    }
  }
}`,
}

export default {
    right: Right,
    left: Delv.queryHOC(Left, Left.delvConfig),
}
